
import ListComponent from "../../../components/add_point_records/Index.vue";

export default {
  components: {
    ListComponent
  }
}
